import { render, staticRenderFns } from "./tagsearch.vue?vue&type=template&id=1d2bf02c&scoped=true&"
import script from "./tagsearch.vue?vue&type=script&lang=js&"
export * from "./tagsearch.vue?vue&type=script&lang=js&"
import style0 from "./tagsearch.vue?vue&type=style&index=0&id=1d2bf02c&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2bf02c",
  null
  
)

export default component.exports